// Canonical mapping from item.availability.status (Greek labels written by
// the items pipeline) to English codes consumed by GA4. Verified against the
// live items collection on 2026-04-28 — the original keys hadn't matched a
// single actual status, so every dataLayer event was shipping
// item_availability: undefined.
export const AVAILABILITY_MAP = {
  "Άμεσα Διαθέσιμο":           "central_stock",
  "Άμεσα διαθέσιμο":           "central_stock",
  "Διαθέσιμο σε 24 με 48 ώρες": "central_stock",
  "Διαθέσιμο από 1–3 ημέρες":  "central_stock",
  "Διαθέσιμο σε Φαρμακείο":    "pharmacy_only",
  "Προσωρινά Εξαντλημένο":     "out_of_stock",
  "Μη διαθέσιμο":              "out_of_stock",
};

export const getItemAvailability = (item) => {
  const status = ((item || {}).availability || {}).status;
  return AVAILABILITY_MAP[status] || undefined;
};

// Coerce a possibly-stringy/undefined money value into a finite Number,
// rounded to `d` decimals. GA4/Ads/Meta require numeric value & price.
export const toSafeFixed = (v, d = 2) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? Number(n.toFixed(d)) : 0;
};

export const prepareItem = (item, index = 0) => {
  const obj = {
    item_id: item.sku || item.barcode,
    item_name: item.description,
    price: toSafeFixed((item.prices || {}).price, 2),
    item_brand: item.manufacturer,
    item_category: item.business_activity,
    item_list_name: item.business_activity,
    item_variant: item.variant,
    position: index,
    quantity: item.quantity,
    index,
    item_availability: getItemAvailability(item),
  };
  if (item.family) {
    obj.item_category2 = item.family;
    obj.item_list_name = item.family;
  }
  if (item.subfamily) {
    obj.item_category3 = item.subfamily;
    obj.item_list_name = item.subfamily;
  }
  if (item.category) {
    obj.item_category4 = item.category;
    obj.item_list_name = item.category;
  }
  return obj;
};

export const buildPurchaseEvent = (cart) => {
  if (!cart) return null;
  const transactionId = cart.fid || cart.order_id;
  const items = (cart.items || []).map((it, i) => prepareItem(it, i));
  if (!transactionId || items.length === 0) return null;
  return {
    event: "purchase",
    // GA4 reads the commerce payload from the nested `ecommerce` object.
    ecommerce: {
      transaction_id: String(transactionId),
      currency: "EUR",
      value: toSafeFixed(cart.sum, 2),
      tax: toSafeFixed(cart.vat, 2),
      shipping: toSafeFixed((cart.shipping || {}).cost, 2),
      items,
    },
    // Enhanced-conversion / custom fields stay at the event root.
    email: (cart.user || {}).email,
    phone: (cart.user || {}).phone,
    phone_order: !!((cart.operator || {}).id),
  };
};
